export function QFieldDisplayInfo() {
  this.displayName = "";
  this.fieldValue = "";
  this.containsField = "";
  this.breakChars = null;
  this.escbreakChars = null;
}
